import React, { useState } from 'react';

export interface TimeInputStateReturn {
	value: number;
	error: string;
	setValue: React.Dispatch<React.SetStateAction<number>>;
	setError: React.Dispatch<React.SetStateAction<string>>;
	handleChange: (input: string) => void;
}

export const useTimeInputState = (
	initialValue: number,
): TimeInputStateReturn => {
	const [value, setValue] = useState<number>(initialValue);
	const [error, setError] = useState<string>('');

	const handleChange = (input: string): void => {
		const trimmedValue = input.substring(0, 5);
		const regex = /^\d*\.?\d{0,2}$/;

		if (trimmedValue === '' || regex.test(trimmedValue)) {
			const parsedValue = parseFloat(trimmedValue);
			setValue(parsedValue);

			if (Number.isNaN(parsedValue)) {
				setError('Time is required');
			} else if (parsedValue < 0.01) {
				setError("Time can't be less than 0.01");
			} else if (parsedValue > 24) {
				setError("Time can't be more than 24");
			} else {
				setError('');
			}
		}
	};

	return { value, error, setValue, setError, handleChange };
};
